// import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { ADMIN_SERVICE_URL } from "../../app/configs";
import { translate } from "../../app/utils";
import servicesImg from "../../assets/images/services.png";
import "./about.css";

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState("history");

  useEffect(() => {
    const hashTab = window.location.hash.replace("#", "") || "library";
    setActiveTab(hashTab);
  }, []);

  useEffect(() => {
    window.history.replaceState(null, "", `#${activeTab}`);
  }, [activeTab]);

  return LibraryServices();
  // <div className="tabs-page app-padding">
  //   <div className="views">
  //     <TabViews activeTab={activeTab} />
  //   </div>
  //   <div className="tabs">
  //     <AppTabs
  //       tabs={tabs}
  //       activeTab={Math.max(
  //         tabs.findIndex((tab) => tab.value === activeTab),
  //         0
  //       )}
};

const LibraryServices = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("fade-in-visible");
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(section);
    return () => observer.unobserve(section);
  }, []);

  return (
    <section ref={sectionRef} className="library-section fade-in">
      <div className="library-container">
        <div id="floating-container">
          <div className="library-image zoom-hover">
            <img src={servicesImg} alt="Library Services Overview" />
          </div>
          <div id="text-container">
            <h2>{translate("aboutUsTitle")}</h2>

            <p>{translate("aboutUsDescription")}</p>

            <div className="brochure-download">
              <a
                href={`${ADMIN_SERVICE_URL}/uploads/LIBRARY SERVICES BROCHURE.pdf`}
                download
                className="download-btn pulse-btn"
                aria-label="Download Library Brochure"
                role="button"
              >
                📥 {translate("downloadBrochure")}
              </a>
            </div>
          </div>
        </div>

        <div id="objectives-container">
          <h3>{translate("ourObjectives")}</h3>

          <ul className="modern-list">
            <li>{translate("aboutItem1")}</li>
            <li>{translate("aboutItem2")}</li>
            <li>{translate("aboutItem3")}</li>
            <li>{translate("aboutItem4")}</li>
            <li>{translate("aboutItem5")}</li>
            <li>{translate("aboutItem6")}</li>
            <li>{translate("aboutItem7")}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
